import { z } from 'zod/v4'

export const listResourceSchema = z.object({
  page: z.number(),
  per_page: z.number(),
  total: z.number(),
  total_page: z.number(),
})
